<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M11.0006 6.36059L11.0006 16.9989L9.00062 16.9989L9.00062 6.36495L7.63782 7.72834L6.45502 6.54655L10.0015 3.00119L11.7749 4.77277L13.5468 6.54655L12.365 7.72812L11.0006 6.36059Z"
    fill="currentColor"
  />
</svg>
